import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { ResetPasswordComponent } from "../components/authentication/components/reset-password/reset-password.component";
import { AuthenticationComponent } from "../components/authentication/components/authentication/authentication.component";
import { FinishRegisterComponent } from "../components/authentication/components/finish-register/finish-register.component";
import { LoginComponent } from "../components/authentication/components/login/login.component";
import { MailConfirmationComponent } from "../components/authentication/components/mail-confirmation/mail-confirmation.component";
import { MailVerificationComponent } from "../components/authentication/components/mail-verification/mail-verification.component";
import { PreRegisterComponent } from "../components/authentication/components/pre-register/pre-register.component";
import { RegisterComponent } from "../components/authentication/components/register/register.component";
import { HasValidURLTokenGuard } from "../guards/authentication/has-valid-url-token.guard";
import { RegistrationIsEnabledGuard } from "../guards/authentication/registration-enabled.guard";

export class AuthenticationRoutingFactory extends BaseRoutingFactory {
    
    private readonly coreAuthenticationRoute: Routes = [
        {
            path: '',
            component: AuthenticationComponent,
            children: [
                {
                    path: '',
                    redirectTo: '/authentication/login',
                    pathMatch: 'full'
                },
                {
                    path: 'login',
                    component: LoginComponent,
                },
                {
                    path: 'register',
                    component: RegisterComponent,
                    canActivate: [HasValidURLTokenGuard, RegistrationIsEnabledGuard]
                },
                {
                    path: 'finishregister',
                    component: FinishRegisterComponent,
                    canActivate: [HasValidURLTokenGuard]
                },
                {
                    path: 'preregister',
                    component: PreRegisterComponent,
                    canActivate: [RegistrationIsEnabledGuard]
                },
                {
                    path: 'resetpassword',
                    component: ResetPasswordComponent,
                    canActivate: [HasValidURLTokenGuard]
                },
                {
                    path: 'mailverification',
                    component: MailVerificationComponent,
                },
                {
                    path: 'mailconfirmation',
                    component: MailConfirmationComponent,
                }
            ]
        }
    ];

    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }

    protected get coreRoute(): Routes {
        return this.coreAuthenticationRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route): void {
        const formRoutes = coreRoute![0].children!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
        }
        else {
            coreRoute![0].children!.push(route);
        }
    }
    
}